import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ReactComponent as PendingIcon } from '../../assets/icons/loading.svg';
import './StatusIcon.scss';

type StatusType = 'success' | 'error' | 'pending' | 'disabled-pending';

interface StatusIconProps {
    status: StatusType;
    className?: string;
}

const StatusIcon: React.FC<StatusIconProps> = ({ status, className }) => {
    switch (status) {
        case 'success':
            return <CheckCircleOutlineIcon className={`StatusIcon ${className}`.trim()} />;
        case 'error':
            return <ErrorOutlineIcon className={`StatusIcon ${className}`.trim()} />;

        case 'pending':
        case 'disabled-pending':
            return <PendingIcon className={`StatusIcon animate-spin status-${status} ${className}`.trim()} />;

        default:
            return null;
    }
};

export default StatusIcon;
